import { UnleashClient } from 'unleash-proxy-client'
import Config from '@/config'
import Sentry from '@/3rd-parties/sentry'

class UnleashService {
  constructor() {
    try {
      this.unleashClient = new UnleashClient({
        url: Config.unleashEndpoint,
        clientKey: Config.unleashClientKey,
        appName: 'presenter',
        createAbortController: () => null,
      })
      this.onReadyPromise = new Promise((resolve) => {
        this.unleashClient.on('ready', resolve)
        this.unleashClient.on('error', resolve)
      })

      this.unleashClient.start()
    } catch (error) {
      Sentry.captureException(error)
      this.unleashClient = null
    }
  }

  async waitForInitialization() {
    await this.onReadyPromise
  }

  isFeatureEnabled(featureName) {
    if (!this.unleashClient) {
      return false
    }

    try {
      return this.unleashClient.isEnabled(featureName)
    } catch (error) {
      return false
    }
  }

  getVariant(featureName) {
    if (!this.unleashClient) {
      return { name: 'disabled', enabled: false }
    }

    try {
      return this.unleashClient.getVariant(featureName)
    } catch (error) {
      return { name: 'disabled', enabled: false }
    }
  }
}

export default new UnleashService()
